import { API_GET_LIST_PROFESSIONAL_SEMINAR_SELF_SUCCESS, API_GET_LIST_PROFESSIONAL_SEMINAR_ORGANIZATION_SUCCESS, API_GET_ONE_PROFESSIONAL_SEMINAR_ONE_SUCCESS, } from '../actions/ProfessionalSeminarActions';
const INITIAL_STATE = {
    one: {},
    organizationSeminarTotal: 0,
    organizationSeminars: {},
    selfSeminarTotal: 0,
    selfSeminars: {},
};
// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, { meta, payload, total, type }) => {
    switch (type) {
        // 自身が作成したセミナー一覧取得
        case API_GET_LIST_PROFESSIONAL_SEMINAR_SELF_SUCCESS: {
            return Object.assign(Object.assign({}, state), { selfSeminarTotal: total, selfSeminars: Object.assign(Object.assign({}, state.selfSeminars), { [meta.page]: payload.list }) });
        }
        // 自身と同じ組織のコンサルが作成したセミナー一覧取得
        case API_GET_LIST_PROFESSIONAL_SEMINAR_ORGANIZATION_SUCCESS: {
            return Object.assign(Object.assign({}, state), { organizationSeminarTotal: total, organizationSeminars: Object.assign(Object.assign({}, state.organizationSeminars), { [meta.page]: payload.list }) });
        }
        // セミナー取得
        case API_GET_ONE_PROFESSIONAL_SEMINAR_ONE_SUCCESS: {
            return Object.assign(Object.assign({}, state), { one: Object.assign(Object.assign({}, state.one), { [payload.id]: payload }) });
        }
        default: {
            return state;
        }
    }
};
